import React from 'react';
import queryHasura from '../../../core/fetch/queryHasura';
import { getp } from '../../../helpers/getProp';
import PageableTables from './PageableTables';
import _ from 'lodash';
import flatten from 'flat';

export default function(queryInfo) {
  console.log('useTableData - start');
  if (!queryInfo) {
    console.log('useTableData - queryInfo required');
  }
  const [data, setData] = React.useState([]);
  const [loading, setLoading] = React.useState(false);
  const [pageCount, setPageCount] = React.useState(0);
  const [columns, setColumns] = React.useState([]);

  const removeRow = idx => {
    const newData = data.slice();
    newData.splice(idx, 1);
    setData(newData);
  };

  const fetchData = React.useCallback(async ({ pageSize = 10, pageIndex = 0 }) => {
    // console.log('Start fetchData');
    // Set the loading state
    setLoading(true);
    const offset = pageSize * pageIndex;
    const limit = pageSize;

    let res;
    try {
      res = await queryHasura(getQuery(queryInfo, pageCount), { limit, offset }, null, null, true);
    } catch (err) {
      console.log('useTableData Fetch - Error ', err);
    }
    if (!res || res.errors) {
      console.log('Error from useTableData Fetch Results', res);
    }

    const deets = getp(res, 'data.' + queryInfo.operationName);
    console.log('deets', res);
    setData(deets);
    if (!pageCount) {
      const totalRecords = getp(
        res,
        'data.' + queryInfo.operationName + '_aggregate.aggregate.count',
      );
      // console.log('totalRecords', totalRecords);
      setPageCount(Math.ceil(totalRecords / pageSize));
    }

    if (!columns.length) {
      const columnData = buildColumnsFromResults(deets, queryInfo);
      setColumns(columnData);
    }

    setLoading(false);
  }, []);

  // React.useEffect(() => {
  //   console.log('UTD - uE');
  //   fetchData({});
  // }, []);

  // console.log('End fetchData');

  return {
    data,
    loading,
    pageCount,
    fetchData,
    columns,
    removeRow,
  };
}

function buildColumnsFromResults(data, queryInfo) {
  console.log('data,queryInfo', data, queryInfo);
  if (!data || !data.length) return 0;
  if (queryInfo.columns) {
    const columns = Object.keys(queryInfo.columns).map(key => {
      const path = queryInfo.columns[key];
      const column = {
        Header: key[0].toUpperCase() + key.substring(1),
        accessor: path,
        type: queryInfo.columnTypes ? queryInfo.columnTypes[key] : null,
      };
      // const dataExpanded = getp(data[0], path);
      // if (Array.isArray(dataExpanded)) {
      //   delete column.accessor;
      //   delete column.type;
      //   const d = dataExpanded[0];
      //   column.columns = [];
      //   Object.keys(d).forEach(key2 => {
      //     column.columns.push({
      //       Header: key2[0].toUpperCase() + key2.substring(1),
      //       accessor: path + '.' + key2,
      //       type: queryInfo.columnTypes[key2],
      //     });
      //   });
      // }
      return column;
    });
    return columns;
  } else {
    const flattened = flatten(data[0]);
    const keys = Object.keys(flattened);
    // console.log('keys', keys);
    const columns = keys.map(key => {
      const header = key.substring(key.lastIndexOf('.') + 1);
      return {
        Header: header[0].toUpperCase() + header.substring(1),
        accessor: key,
        type: queryInfo.columnTypes ? queryInfo.columnTypes[key] : null,
      };
    });
    return columns;
  }
}

function getQuery(queryInfo, totalPages) {
  // console.log('gQ - totalages', totalPages);
  if (totalPages) {
    const q = queryInfo.query.replace('@@@@', '');
    // console.log('q1', q);
    return q;
  } else {
    const q = queryInfo.query.replace('@@@@', queryInfo.aggregateQuery);
    // console.log('q2', q, queryInfo.query, queryInfo.aggregateQuery);
    return q;
  }
}

// const temp1 = [
//   {
//     email: 'Stormtroopin011@gmail.com',
//     id: '09c0cb10-bdde-11e9-ba4b-f7d5340cfd4a',
//     document_verifications: [
//       {
//         file_name: 'documents/f1a5a7dca7ff094c5ee5c45364baea40.jpeg',
//         document_status: 'pending',
//       },
//     ],
//     user_profiles: [
//       {
//         first_name: 'Joel',
//         last_name: 'Haddock ',
//       },
//     ],
//   },
//   {
//     email: 'Danielspalding3@gmail.com',
//     id: '1861c760-bdf1-11e9-bf8e-5131da123e06',
//     document_verifications: [
//       {
//         file_name: 'documents/b006cdd550f3533a85e7f3ed1f66a675.jpeg',
//         document_status: 'pending',
//       },
//       {
//         file_name: 'documents/305eb33bc7356e22e2833f41e4bf770c.jpeg',
//         document_status: 'pending',
//       },
//     ],
//     user_profiles: [
//       {
//         first_name: 'Daniel',
//         last_name: 'Spalding',
//       },
//     ],
//   },
//   {
//     email: 'johnnydance@gmail.com',
//     id: '4a2675c0-bacc-11e9-83ee-21b36aca91bb',
//     document_verifications: [
//       {
//         file_name: 'documents/72284a694c0cf2d10c9263d204a38b88.jpeg',
//         document_status: 'pending',
//       },
//       {
//         file_name: 'documents/01dedb6419b475a03eecdd85fcfff7a4.jpeg',
//         document_status: 'pending',
//       },
//     ],
//     user_profiles: [
//       {
//         first_name: 'Johnny',
//         last_name: 'Dance',
//       },
//     ],
//   },
//   {
//     email: 'blairtolman@comcast.net',
//     id: '37e000f0-bb91-11e9-83ee-21b36aca91bb',
//     document_verifications: [
//       {
//         file_name: 'documents/01349bbf1ce1c056218b6175f092d12a.jpeg',
//         document_status: 'pending',
//       },
//       {
//         file_name: 'documents/d8bdc986cf2fc06f29705c1b183c024f.jpeg',
//         document_status: 'pending',
//       },
//     ],
//     user_profiles: [
//       {
//         first_name: 'Blair',
//         last_name: 'Tolman',
//       },
//     ],
//   },
//   {
//     email: 'niklee361@gmail.com',
//     id: '5879d0c0-b93e-11e9-b03d-492d0771a050',
//     document_verifications: [
//       {
//         file_name: 'documents/ca47de02dafe3ceb46a7b64fac59e801.jpeg',
//         document_status: 'pending',
//       },
//     ],
//     user_profiles: [
//       {
//         first_name: 'Nikki',
//         last_name: 'Anderson',
//       },
//     ],
//   },
//   {
//     email: 'elmio915@yahoo.com',
//     id: '6e79a700-bb8d-11e9-83ee-21b36aca91bb',
//     document_verifications: [
//       {
//         file_name: 'documents/54273caa6a31177c39bf03ac3b6c2354.jpeg',
//         document_status: 'pending',
//       },
//       {
//         file_name: 'documents/12bc0282e2a4efabdece5100b10b6915.jpeg',
//         document_status: 'pending',
//       },
//       {
//         file_name: 'documents/b4ba80fec7fa295595848903b5835e7e.jpeg',
//         document_status: 'pending',
//       },
//     ],
//     user_profiles: [
//       {
//         first_name: 'Ben ',
//         last_name: 'Marquez',
//       },
//     ],
//   },
//   {
//     email: 'blackjuliac@gmail.com',
//     id: '77a3fc10-b93d-11e9-b03d-492d0771a050',
//     document_verifications: [
//       {
//         file_name: 'documents/603aad1b6777ef2f0331c05df285aab9.jpeg',
//         document_status: 'pending',
//       },
//     ],
//     user_profiles: [
//       {
//         first_name: 'Julia',
//         last_name: 'Black',
//       },
//     ],
//   },
//   {
//     email: 'Mimmoon16@gmail.com',
//     id: '858d0a70-ba4a-11e9-aae4-557b7157f917',
//     document_verifications: [
//       {
//         file_name: 'documents/8e375603febeab3ead17ba5eeaefae2e.jpeg',
//         document_status: 'pending',
//       },
//       {
//         file_name: 'documents/99aeccc7e1452d37d7435791802d2c62.jpeg',
//         document_status: 'pending',
//       },
//     ],
//     user_profiles: [
//       {
//         first_name: 'Mimmoon ',
//         last_name: 'Chowdhury ',
//       },
//     ],
//   },
//   {
//     email: 'josh.r.burningham@gmail.com',
//     id: '86aad320-bc92-11e9-9991-6be7a332cc1a',
//     document_verifications: [
//       {
//         file_name: 'documents/bc59cf4eb47ac018bff70ba1b99c6c7f.jpeg',
//         document_status: 'pending',
//       },
//     ],
//     user_profiles: [
//       {
//         first_name: 'Josh',
//         last_name: 'Burningham ',
//       },
//     ],
//   },
//   {
//     email: 'Califromcali@gmail.com',
//     id: '88766a10-be00-11e9-bf8e-5131da123e06',
//     document_verifications: [
//       {
//         file_name: 'documents/fee1e23c124ce5953d886020b4db9182.jpeg',
//         document_status: 'pending',
//       },
//       {
//         file_name: 'documents/0794408f43755018cb717c10b9d1710b.jpeg',
//         document_status: 'pending',
//       },
//     ],
//     user_profiles: [
//       {
//         first_name: 'Cali',
//         last_name: 'Hernandez',
//       },
//     ],
//   },
// ];

// const temp2 = {
//   operationName: 'user',
//   query:
//     'query getDocumentsToVerify($limit: Int, $offset: Int) {\n      user(where: {document_verifications: {document_status: {_eq: "pending"}}}, limit: $limit, offset: $offset) {\n        email\n        id\n        document_verifications {\n          file_name\n          document_status\n        }\n        user_profiles {\n          first_name\n          last_name\n        }\n      }\n      @@@@\n    }\n    ',
//   aggregateQuery:
//     'user_aggregate(where: {document_verifications: {document_status: {_eq: "pending"}}}, limit: $limit, offset: $offset) {\n      aggregate{\n        count\n      }\n    }',
//   columnTypes: {
//     file_name: 'img',
//   },
//   columns: {
//     email: 'email',
//     id: 'id',
//     documentVerifications: 'document_verifications',
//     firstName: 'userProfiles.0.first_name',
//     lastName: 'userProfiles.0.last_name',
//   },
// };

// const resData = [
//   {
//     id: 287,
//     hostId: 'c98a28b0-19c4-11e9-b6f4-1d1e5ebf963c',
//     checkIn: '2020-03-08',
//     checkOut: '2020-03-09',
//     hostPayouts: [
//       {
//         payEmail: 'natalie@motiis.com',
//         id: 8,
//         isDefault: true,
//       },
//     ],
//     total: 20,
//     transaction_histories: [],
//     reservationState: 'completed',
//     hostServiceFee: 2,
//     listing: {
//       title: 'Camera - fuji Film xs100',
//     },
//     userByHostId: {
//       user_profiles: [
//         {
//           first_name: 'Jason',
//           last_name: 'Fairbourne',
//           profile_id: 7,
//         },
//       ],
//       email: 'jason@yoodlize.com',
//     },
//   },
// ];

// buildColumnsFromResults(resData, PageableTables.payouts); //?



// WEBPACK FOOTER //
// ./src/routes/siteadmin/pageableTable/useTableData.js